import { render, staticRenderFns } from "./MonthlyRoyaltyIncentive.vue?vue&type=template&id=06f72655&"
import script from "./MonthlyRoyaltyIncentive.vue?vue&type=script&lang=js&"
export * from "./MonthlyRoyaltyIncentive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports